import {
    Box,
    Center,
    Stack,
    Text,
    Link,
} from "@chakra-ui/layout";

import {
    Switch,
    useColorModeValue as mode,
    Tooltip,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalBody,
    ModalContent,
    FormControl,
    Input,
    ModalCloseButton,
    FormLabel,
    ModalFooter,
    Img,
    Button,
} from "@chakra-ui/react";
import theme from "@chakra-ui/theme";
import SearchBar from "components/search-bar";
import Tweets from "components/tweets";
import { CustomHead } from "components/custom-head";
import React, { useEffect, memo } from "react";
import { useSession } from "next-auth/client";
import { firebaseClient } from "../../firebaseClient";
import { getAccount, updateUser } from "../../utils/sessionHelper";
import { useRouter } from "next/dist/client/router";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import toast from "react-hot-toast";
import { SaveIcon } from "components/icons/SaveIcon";

export const EditKeywords = ({ isOpen, onClose, popupMode, setPopupMode, sendRequest }) => {

    const initialRef = React.useRef<HTMLInputElement>(null);
    const [session, loading] = useSession();
    const [isLoading, setIsLoading] = React.useState(false);
    const [keywords, setKeywords] = React.useState("");
    const router = useRouter();
    const isAuthenticated = useFirebaseUser();

    useEffect(() => {
        if (isOpen && getAccount(session)?.keywords?.join) {
            setKeywords(getAccount(session).keywords.join(","));
        }
    }, [session, isAuthenticated, isOpen]);

    const closePopup = () => {
        setPopupMode("edit");
        onClose();
    }

    const saveKeywords = async () => {
      if (!keywords) {
        toast.error("Please, add at least 1 keyword")
        return
      }
      closePopup();
      setIsLoading(true);
      if (session?.user?.uid) {
          // const db = firebaseClient.firestore();
          // await db.collection("users").doc(session?.user?.uid).update({ keywords: keywords.split(",") });
          // session.user.data.keywords = keywords.split(",");
          await updateUser(session, { keywords: keywords.split(",") }, true, true);
          sendRequest(session);
          setIsLoading(false);
      }
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={closePopup}
            closeOnOverlayClick={false}
            //@ts-ignore
            initialFocusRef={initialRef}
            size="xl"
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Box display="flex" justifyContent="space-between">
                        {popupMode == "fail" ? "⚠️ Failed to auto-analyze your account" : "Improve the search relevancy"}
                    </Box>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <FormControl
                        as="form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            saveKeywords();
                        }}
                    >
                        <FormLabel pb={3} pl={1} fontSize="md" fontWeight="400" >{
                            popupMode == "fail" ?
                                "There is not enough recent tweets on your account for us to analyze. Please enter a few keywords (comma separated)"
                                : (
                                    <Box display="flex" flexDirection="column" alignItems="flex-start">
                                        Enter 3 to 10 keywords (comma separated) that will be used to search inspiration tweets.
                                        <Button variant="tertiaryNoBackground">
                                        <Link mt={2} textDecoration="underline" onClick={() => {
                                            router.push("/settings");
                                        }}>
                                            Or edit all the search parameters in the settings
                                        </Link>
                                        </Button>
                                    </Box>
                                )
                        }</FormLabel>
                        <Input ref={initialRef} placeholder="marketing,startup,bitcoin" value={keywords} onChange={(e) => setKeywords(e.target.value)} />
                    </FormControl>
                </ModalBody>

                <ModalFooter mb={2}>
                    {/* <Button onClick={skipPopup} mr={3}>Skip</Button> */}
                    <Button variant="tertiary" onClick={onClose}>Cancel</Button>
                    <Button onClick={async () => {
                        saveKeywords();
                    }}
                        variant={"primary"} isLoading={isLoading}
                        leftIcon={SaveIcon}
                        >
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
